/**
 * Galego — idioma de referencia. Si falta una clave en otro idioma, se cae a
 * este, nunca a un hueco en blanco.
 */
export const gl = {
  app: {
    name: 'Personaliza',
    brand: 'Besbello',
    loading: 'Cargando...',
    retry: 'Reintentar',
    dismiss: "Descartar",
    cancel: 'Cancelar',
    save: 'Gardar',
    close: 'Pechar',
    back: 'Atras',
    next: 'Seguinte',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    search: 'Buscar',
    error: 'Algo foi mal',
    offline: 'Sen conexion. Os cambios gardanse cando volva.',
  },
  nav: {
    catalog: 'Catalogo',
    myOrders: 'Os meus pedidos',
    account: 'A mina conta',
    admin: 'Administracion',
    login: 'Entrar con Besbello',
    loginLocal: 'Entrar',
    logout: 'Saír',
  },
  catalog: {
    title: 'Escolle o teu produto',
    subtitle: 'Camisetas, sudadeiras, gorras e tazas para personalizar.',
    searchPlaceholder: 'Buscar por nome ou referencia',
    family: {
      all: 'Todo',
      tshirt: 'Camisetas',
      sweatshirt: 'Sudadeiras',
      cap: 'Gorras',
      mug: 'Tazas',
      bag: 'Bolsas',
      other: 'Outros',
    },
    colors: '{count} cores',
    empty: 'Non hai produtos con eses filtros.',
    noPrice: 'Sen tarifa cargada',
    notCustomizable: 'Aínda sen zona de marcaxe',
    personalize: 'Personalizar',
  },
  product: {
    chooseColor: 'Cor',
    chooseZone: 'Zona de marcaxe',
    chooseTechnique: 'Tecnica',
    chooseSize: 'Talla de referencia',
    zoneNote: 'A zona cambia coa talla: o deseno adaptase.',
    start: 'Comezar a desenar',
    material: 'Composicion',
    provenance: {
      inherited: 'Zona herdada do patron',
      adjusted: 'Zona axustada para este produto',
      exception: 'Zona con excepcion aberta',
    },
    confidence: 'Confianza {value}%',
    notCalibrated: 'Este produto aínda non ten zona de marcaxe',
    notCalibratedHelp: 'Falta calibralo. Escribe a Besbello e preparámosche o deseño a man.',
  },
  editor: {
    shareReady: "Ligazón de só lectura. Vale 7 días.",
    share: "Compartir",
    title: 'Editor',
    addImage: 'Imaxe',
    addText: 'Texto',
    addShape: 'Forma',
    maxSize: "Esta imaxe chega ben ata {w} × {h} mm a {dpi} ppp.",
    fitToMax: "Axustar a {w} mm de ancho",
    removeBackground: "Quitar o fondo",
    vectorize: "Vectorizar",
    crop: "Recorte",
    crop_libre: "Orixinal",
    crop_cuadrado: "Cadrado",
    crop_apaisado: "Apaisado",
    crop_vertical: "Vertical",
    imageMode: "Tratamento",
    mode_ninguno: "Como está",
    mode_grises: "Grises",
    mode_contrasteAlto: "Alto contraste",
    mode_unaTinta: "Unha tinta",
    brightness: "Brillo",
    contrast: "Contraste",
    saturation: "Saturación",
    threshold: "Limiar",
    noImagesYet: "Aínda non subiches ningunha imaxe.",
    reuseThis: "Usar esta imaxe",
    adjustFit: "Axustar onde cae o estampado",
    adjustFitHelp: "Arrastra o recadro sobre a foto. Afecta a todos os deseños deste produto.",
    mmPerPixel: "mm por píxel",
    rotateZone: "Xirar a zona a {ancho} × {alto} mm",
    saveFit: "Gardar o encaixe",
    fitSaved: "Encaixe gardado e confirmado.",
    fix_resize: "Reducir a {valor} mm de ancho",
    fix_moveInside: "Meter dentro da zona",
    fix_thickenStroke: "Engrosar o trazo a {valor} mm",
    fix_growText: "Subir o texto a {valor} mm",
    fix_widenArc: "Abrir o arco a {valor} mm de raio",
    nudgeUp: "Subir un paso",
    nudgeDown: "Baixar un paso",
    nudgeLeft: "Mover á esquerda",
    nudgeRight: "Mover á dereita",
    nudgeHelp: "Axuste fino. Preme o número para cambiar entre 1 e 10 mm.",
    canvasLabel: "Lenzo do deseño",
    zones: "Zonas desta peza",

    copyToZone: "Copiar a {zona}",
    inkColor: "Cor da tinta",
    inks: "{n} tintas",
    tooManyInks: "máximo {max}",
    screens: "{n} pantallas de serigrafía.",
    whiteBaseNeeded: "Sobre peza escura fai falta base branca debaixo: é unha pantalla máis e vai incluída no prezo.",
    pantoneNote: "As cores de pantalla son aproximadas. A tinta pídese pola súa referencia.",
    view3d: "En 3D",
    downloadMockup: "Descargar a imaxe",

    proofSheet: "Folla de proba (PDF)",
    downloadFailed: "Non se puido preparar a imaxe da peza.",
    mockupDisclaimer: "Vista orientativa. Non substitúe unha proba impresa.",
    templates: "Modelos",
    templatesHelp: "Un punto de partida que podes cambiar enteiro.",

    templateInsert: "Inserir cos meus datos",
    group: "Agrupar",
    ungroup: "Separar",
    copyDesign: "Copiar a outra peza",
    copyDesignDone: "Deseño copiado. Ábreo na outra peza.",
    bringDesign: "Tes copiado o deseño de {producto} · {zona}.",
    bringDesignAction: "Traelo aquí",
    bringDesignDone: "traer o deseño doutra peza",
    myImages: "As miñas imaxes",
    reuseImage: "Xa as subiches antes; reutilízaas sen volver buscalas.",
    ratioLocked: "Proporción bloqueada",
    ratioFree: "Proporción libre",
    alignTools: "Aliñar",
    distributeH: "Repartir en horizontal",
    distributeV: "Repartir en vertical",
    alignTop: "Arriba",
    alignMiddle: "Centro",
    alignBottom: "Abaixo",
    selectedCount: "{n} capas seleccionadas",
    zoomIn: "Achegar",
    zoomOut: "Afastar",
    zoomFit: "Axustar á zona",
    zoomReset: "Tamaño real",
    weight: "Peso",
    weightNormal: "Normal",
    weightBold: "Negra",
    weightBlack: "Moi negra",
    italic: "Cursiva",
    align: "Aliñación",
    align_left: "Esquerda",
    align_center: "Centro",
    align_right: "Dereita",
    align_justify: "Xustificado",
    textCase: "Maiúsculas",
    case_none: "Orixinal",
    case_upper: "MAIÚS",
    case_lower: "minús",
    arc: "Arco",
    arcHint: "Curva o texto, coma nun escudo.",
    arc_none: "Recto",
    arc_up: "Cara arriba",
    arc_down: "Cara abaixo",
    outline: "Contorno",
    outlineHint: "Necesario se o texto non contrasta coa prenda.",
    fontGroup: { neutra: "Neutras", condensada: "Estreitas", impacto: "De impacto", serif: "Con remate", manuscrita: "Manuscritas", redondeada: "Redondeadas", decorativa: "Decorativas" },
    undo: 'Desfacer',
    redo: 'Refacer',
    viewFlat: 'Plano',
    viewGarment: 'Na prenda',

    viewWorn: "Posto",
    layers: 'Capas',
    layer: 'Capa',
    properties: 'Propiedades',
    position: 'Posicion',
    size: 'Tamano',
    rotation: 'Rotacion',
    opacity: 'Opacidade',
    color: 'Cor',
    font: 'Tipografia',
    textContent: 'Texto',
    delete: 'Eliminar capa',
    duplicate: 'Duplicar',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    bringForward: 'Subir',
    sendBackward: 'Baixar',
    center: 'Centrar',
    fitZone: 'Axustar a zona',
    zoneOutline: 'Zona de marcaxe',
    saving: 'Gardando...',
    saved: 'Gardado',
    saveError: 'Non se puido gardar',
    conflict: 'Alguen mais editou este deseno',
    conflictHelp: 'Abriches o deseno noutra pestana. Recarga para ver a version actual; o teu traballo non se perdeu.',
    mmUnit: 'mm',
    price: 'Prezo',
    checkout: 'Continuar',
    emptyDesign: 'Engade unha imaxe ou un texto para comezar.',

    contrastTitle: "Hai algo que non se vai ver",

    contrastBody: "Unha capa é case da cor da prenda: estampada apenas se distinguirá.",

    contrastFix: "Cambiar a unha cor visible",
    uploadHint: 'JPG, PNG, WEBP ou SVG. Maximo {mb} MB.',
    photoWarning: 'Se subes unha foto con persoas, precisamos o seu consentimento.',
  },
  diagnostics: {
    title: 'Revision tecnica',
    none: 'Todo correcto para producir.',
    errors: '{count} problemas que impiden producir',
    warnings: '{count} avisos',
    estimated: 'medida estimada',
    codes: {
      LAYER_OUTSIDE_ZONE: 'A capa sae {measured} mm da zona de marcaxe.',
      LAYER_OUTSIDE_CANVAS: 'A capa sae da area visible.',
      DESIGN_AREA_EXCEEDED: 'O deseno ocupa {measured} mm² e o maximo son {expected} mm².',
      ZONE_TECHNIQUE_NOT_ALLOWED: 'Esta zona non admite a tecnica escollida.',
      EFFECTIVE_DPI_TOO_LOW: 'A imaxe queda a {measured} ppp e fan falta {expected}. Usa unha imaxe maior ou reducea.',
      IMAGE_UPSCALED: 'A imaxe esta ampliada: perdera nitidez.',
      TOO_MANY_INKS: 'Hai {measured} tintas e o maximo son {expected}.',
      GRADIENT_NOT_ALLOWED: 'Esta tecnica non reproduce fotografias nin degradados.',
      TECHNICAL_WHITE_NOT_AVAILABLE: 'Esta tecnica non imprime branco de base.',
      COLOR_TYPE_NOT_SUPPORTED: 'Ese tipo de cor non se pode producir con esta tecnica.',
      STROKE_TOO_THIN: 'O trazo mide {measured} mm e o minimo son {expected} mm.',
      ARC_OVERLAP: "O texto en arco dá máis dunha volta e as letras píxanse. Sobe o radio ou acurta o texto.",
      TEXT_TOO_SMALL: 'O texto mide {measured} mm e o minimo son {expected} mm.',
      TEXT_NOT_FROZEN: 'O texto conxelarase antes de producir.',
      GEOMETRY_ESTIMATED: 'A medida desta capa e aproximada ata conxelar o texto.',
      SUBSTRATE_NOT_SUPPORTED: 'O material desta prenda non admite a tecnica escollida.',
      EXTERNAL_DIGITIZING_REQUIRED: 'O bordado precisa dixitalizacion previa; incluese no orzamento.',
      EMPTY_DESIGN: 'O deseno esta baleiro.',
      LAYER_LIMIT_EXCEEDED: 'Hai {measured} capas e o maximo son {expected}.',
    },
  },
  pricing: {
    title: 'Prezo',
    breakdown: 'Desglose',
    subtotal: 'Base',
    vat: 'IVE',
    total: 'Total',
    quantity: 'Unidades',
    validUntil: 'Valido ata {date}',
    expired: 'Este orzamento caducou. Recalculamolo.',
    recalculate: 'Recalcular',
    concepts: {
      PRODUCT_BASE: 'Prenda {sku}',
      SETUP: 'Preparacion do pedido',
      SETUP_PER_INK: 'Preparacion por tinta ({inks} tintas)',
      UNIT_MARKING: 'Marcaxe por unidade',
      PER_INK_UNIT: 'Recargo por tinta ({inks})',
      PER_PASS_UNIT: 'Recargo por pasada ({passes})',
      SURCHARGE: 'Recargo {surcharge}',
      MINIMUM_ORDER_ADJUSTMENT: 'Axuste ao pedido minimo',
    },
    surcharges: {
      LARGE_AREA: 'por area grande',
      DARK_GARMENT_WHITE_BASE: 'por base branca en prenda escura',
    },
  },
  checkout: {
    title: 'Finalizar pedido',
    sizes: 'Tallas e cantidades',
    addSize: 'Engadir talla',
    wallet: 'Moedeiro Besbello',
    walletBalance: 'Saldo dispoñible: {amount}',
    walletUse: 'Pagar con saldo',
    walletNone: 'Non tes tarxeta de fidelizacion asociada.',
    terms: 'Acepto as condicions de contratacion',
    marketing: 'Quero recibir novidades e ofertas (opcional)',
    confirm: 'Confirmar pedido',
    decision: {
      PAYMENT: 'Podes pagar agora',
      MANUAL_QUOTE: 'Este pedido revisao unha persoa',
      WITHIN_THRESHOLDS: 'O importe e a cantidade entran no pago directo.',
      TOTAL_ABOVE_THRESHOLD: 'O importe supera o limite de pago directo.',
      QTY_ABOVE_THRESHOLD: 'A cantidade supera o limite de pago directo.',
      TECHNIQUE_REQUIRES_QUOTE: 'Esta tecnica precisa revision comercial.',
      DESIGN_HAS_BLOCKING_DIAGNOSTICS: 'O deseno ten problemas tecnicos por resolver.',
      QUOTE_EXPIRED: 'O orzamento caducou.',
    },
  },
  orders: {
    repeat: "Pedir outra vez",
    title: 'Os meus pedidos',
    empty: 'Aínda non tes pedidos.',
    reference: 'Referencia',
    status: 'Estado',
    total: 'Total',
    date: 'Data',
    detail: 'Ver pedido',
    cancel: 'Cancelar pedido',
    statuses: {
      DRAFT: 'Borrador',
      AWAITING_PAYMENT: 'Agardando pago',
      PAID: 'Pagado',
      IN_PRODUCTION: 'En produccion',
      READY: 'Listo para recoller',
      DELIVERED: 'Entregado',
      CANCELLED: 'Cancelado',
      REFUNDED: 'Reembolsado',
      QUOTE_REQUESTED: 'Orzamento solicitado',
    },
  },
  admin: {
    title: 'Administracion',
    catalog: 'Catalogo',
    calibration: 'Calibracion',
    exceptions: 'Excepcions',
    sampling: 'Mostraxe',
    pricing: 'Tarifas',
    workshop: 'Taller',
    kpi: {
      title: 'Indicadores',
      coverage: 'Cobertura do catalogo',
      skusPerHour: 'SKU por hora de persoa',
      samplingError: 'Erro detectado na mostraxe',
      openExceptions: 'Excepcions abertas',
      reviewed: 'Revisadas',
    },
    calibrator: {
      title: 'Calibrador de zonas',
      help: 'Arrastra os vertices para axustar a zona sobre a foto. As medidas estan en milimetros reais.',
      confirm: 'Confirmar correccion',
      confirmHelp: 'Unha correccion confirmada sobrevive as reimportacions do catalogo.',
      provenance: 'Procedencia',
      trace: 'Como se calculou',
    },
    import: {
      title: 'Importar catalogo',
      dryRun: 'Simular sen gardar',
      run: 'Importar',
      added: 'Altas',
      updated: 'Cambios',
      retired: 'Retirados',
      conflicts: 'Choques con correccions manuais',
    },
  },
  rgpd: {
    title: 'Datos e privacidade',
    consents: 'Consentimentos',
    marketing: 'Comunicacions comerciais',
    photoUpload: 'Fotos con persoas',
    export: 'Descargar os meus datos',
    erase: 'Solicitar supresion',
    requests: 'As minas solicitudes',
    photoNotice:
      'Se a imaxe que subes ten persoas recoñecibles, e un dato persoal. Precisamos o seu consentimento e podes retiralo cando queiras.',
  },





















  equipo: {





















    titulo: "Equipo",





















    ayuda: "Pega a lista do club: unha liña por persoa («Aitor 10 M», ou con comas). Cada membro valídase co seu nome posto.",





















    sinRoles: "Marca antes que texto é o nome e cal o dorsal, nas propiedades da capa.",





















    cargar: "Cargar a lista",





















    nombre: "Nome",





















    dorsal: "Dorsal",





















    talla: "Talla",





















    estado: "Estado",





















    noCabe: "non cabe",





















    guardar: "Gardar serie ({n})",





















    guardadoOk: "Serie gardada.",





















    conProblemas: "{n} con problemas",





















    rolCampo: "Papel no equipo",





















    rolLibre: "Texto libre",





















  },





















  template: {
    farewell: "Despedida",

    crew: "Peña de festas",

    anniversary: "Aniversario",

    grandpa: "Avoa/ó",

    backNumber: "Dorsal de costas",

    pet: "Mascota",

    kidBirthday: "Aniversario infantil",

    localShop: "Negocio local",

    field: {

      teamName: "Nome do equipo",

      number: "Dorsal",

      crewName: "Nome da peña",

      year: "Ano",

      years: "Anos",

      name: "Nome",

      who: "Avoa ou avó?",

      playerName: "Nome do xogador",

      petName: "Nome da mascota",

      businessName: "Nome do negocio",

      since: "Desde (ano)",

    },
    team: "Equipo",
    company: "Empresa",
    event: "Evento",
    birthday: "Aniversario",
  },
  templateCat: {
    grupo: "Grupo",
    empresa: "Empresa",
    evento: "Evento",
    deporte: "Deporte",
  },
  shape: {
    rectangulo: "Rectángulo",
    "rectangulo-redondeado": "Redondeado",
    circulo: "Círculo",
    linea: "Liña",
    triangulo: "Triángulo",
    estrella: "Estrela",
    poligono: "Polígono",
    corazon: "Corazón",
    flecha: "Frecha",
    escudo: "Escudo",
    banderola: "Bandeirola",
  },
  designs: {
    title: "Os meus deseños",
    empty: "Aínda non empezaches ningún deseño.",
    browse: "Ver o catálogo",
    layers: "{n} elementos",
    expiresIn: "caduca en {n} días",
  },
  shared: {
    gone: "Esta ligazón xa non vale",
    noDesign: "Este deseño está baleiro.",
    readOnly: "Vista orientativa e de só lectura. Non substitúe unha proba impresa.",
    expires: "A ligazón vale ata o {fecha}.",
  },
};
